import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  year = '';
  version = 'v1.0.0';
  ngOnInit(): void {
    this.year = new Date().getFullYear().toString();
    this.version = `version: ${environment.version}`;
  }
}
